// @ts-check

import React from 'react';
import { array, func, object } from 'prop-types';
import USER from '../ts/profileEditorEnum';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

/**
 * @component CompanySelector
 * @param {Object} props
 * @param {CompanyType[]} props.values
 * @param {CompanyType[]} props.options
 * @param {EditorValidType} props.valid
 * @param {(name:string, payload:any) => void} props.onHandleUser
 * @returns {JSX.Element}
 */
function CompanySelector({ values, options, valid, onHandleUser }) {
	return (
		<Autocomplete
			fullWidth
			multiple
			value={values}
			options={options}
			// @ts-ignore
			getOptionLabel={(option) => (option.Name ? option.Name : '')}
			onChange={(e, newValue) => onHandleUser(USER.COMPANIES, newValue)}
			renderInput={(params) => {
				return (
					<TextField
						{...params}
						variant="outlined"
						label="Company"
						required
						InputLabelProps={{ shrink: true }}
						size="small"
						error={valid.hasErr}
						helperText={valid.msg}
					/>
				);
			}}
		/>
	);
}

CompanySelector.propTypes = {
	values: array,
	options: array,
	valid: object,
	onHandleUser: func,
};

export default CompanySelector;
